<template>
  <div v-if="datacollection" class="vacancy-stat">
    <VacancyStatChart
      :chart-data="datacollection"
      :height="125"
    ></VacancyStatChart>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import VacancyStatChart from "./VacancyStatChart";

export default {
  components: {
    VacancyStatChart
  },
  props: {
    number: { type: [Number, String], required: true }
  },
  data() {
    return {
      datacollection: null
    };
  },
  apollo: {
    vacancyStats: {
      query: gql`
        query VacancyStats($id: ID!, $filter: VacancyStatsFilter!) {
          vacancyStats(id: $id, filter: $filter) {
            interval
            numDatapoints
            datapoints {
              time
              interval
              amount
              type
            }
          }
        }
      `,
      variables() {
        return {
          id: this.number + "",
          filter: {
            interval: 1440,
            fromTime: moment().subtract(8, "days"),
            metrics: ["VISITORS", "UNIQUE_VISITORS", "APPLICATIONS"]
          }
        };
      }
    }
  },
  watch: {
    vacancyStats(stats) {
      if (!stats.datapoints) {
        this.datacollection = null;
        return;
      }

      stats.datapoints.sort((a, b) =>
        a.time > b.time ? 1 : a.time < b.time ? -1 : 0
      );

      let labels = [];
      for (let data of stats.datapoints) {
        let time = moment(data.time);
        if (labels.findIndex(val => val.diff(time) === 0) === -1) {
          labels.push(time);
        }
      }

      let visitorsData = [];
      let visitorsUniqueData = [];
      let applicationsData = [];
      for (let label of labels) {
        let visitors = 0;
        let visitorsUnique = 0;
        let applications = 0;
        for (let data of stats.datapoints) {
          let time = moment(data.time);
          if (time.diff(label) === 0 && data.type === "VISITORS") {
            visitors = data.amount;
          } else if (
            time.diff(label) === 0 &&
            data.type === "UNIQUE_VISITORS"
          ) {
            visitorsUnique = data.amount;
          } else if (time.diff(label) === 0 && data.type === "APPLICATIONS") {
            applications = data.amount;
          }
        }

        visitorsData.push(visitors);
        visitorsUniqueData.push(visitorsUnique);
        applicationsData.push(applications);
      }

      this.datacollection = {
        labels,
        datasets: [
          {
            label: "Besucher (eindeutig)",
            borderColor: "#13358e",
            data: visitorsUniqueData,
            fill: true,
            backgroundColor: "rgba(19, 53, 142, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0
          },
          {
            label: "Besuche",
            borderColor: "#48c6ef",
            data: visitorsData,
            fill: true,
            backgroundColor: "rgba(72, 198, 239, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0
          },
          {
            label: "Bewerbungen",
            borderColor: "#55c400",
            data: applicationsData,
            fill: true,
            backgroundColor: "rgba(85, 196, 0, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0
          }
        ]
      };
    }
  }
};
</script>
